module.exports = file => () => import('@/pages/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/router/import-production.js